import { IBaseMapper } from '@/bundles/App/interfaces';
import { IAdCampaign } from '@/bundles/Ad/interfaces';
import AdCampaign from '@/bundles/Ad/models/AdCampaign';

export default class AdCampaignToMapper implements IBaseMapper<IAdCampaign> {
  mapToModel (data: IAdCampaign): IAdCampaign {
    return new AdCampaign(data);
  }
}
